import { yieldToEventLoop } from '../../../runtime/yield-to-event-loop.js';
import { resolveBranchCommit } from '../resolve-branch-commit.js';

export async function gitBlobRef(
  repoAbsPath: string,
  branch: string,
  relativePath: string,
): Promise<string | null> {
  const commit = await resolveBranchCommit(repoAbsPath, branch);
  await yieldToEventLoop();
  if (!commit) return null;
  const rel = relativePath.replace(/^\/+/, '').replace(/\\/g, '/');
  if (!rel || rel === '.') return null;
  return `${commit}:${rel}`;
}
